import { theme } from '../../../theme';
import { TSizeValue, TVariantColorValue } from './types';

const { colors } = theme;

export enum FnButtonVariants {
  Primary = 'primary',
  Secondary = 'secondary',
  Active = 'active',
  Success = 'success',
  Warning = 'warning',
  Gray = 'gray'
}

export enum FnButtonTypes {
  Default = 'default',
  Outline = 'outline',
  Text = 'text',
  Icon = 'icon'
}

export enum FnButtonSizes {
  Small = 'small',
  Medium = 'medium'
}

export const VARIANT_COLORS: Record<FnButtonVariants, TVariantColorValue> = Object.freeze({
  [FnButtonVariants.Primary]: {
    mainColor: colors.primary,
    hoverColor: colors.primaryHover
  },
  [FnButtonVariants.Secondary]: {
    mainColor: colors.secondary,
    hoverColor: colors.secondaryHover
  },
  [FnButtonVariants.Active]: {
    mainColor: colors.active,
    hoverColor: colors.activeHover
  },
  [FnButtonVariants.Success]: {
    mainColor: colors.successPrimary,
    hoverColor: colors.successPrimaryHover
  },
  [FnButtonVariants.Warning]: {
    mainColor: colors.error,
    hoverColor: colors.errorHover
  },
  [FnButtonVariants.Gray]: {
    mainColor: colors.textDisabled,
    hoverColor: colors.textDisabledHover
  }
});

export const SIZE_VALUES: Record<FnButtonSizes, TSizeValue> = Object.freeze({
  [FnButtonSizes.Small]: {
    fontSize: '11px',
    padding: '0 12px',
    minHeight: '29px'
  },
  [FnButtonSizes.Medium]: {
    fontSize: '1.078rem',
    padding: '0 2.154rem',
    minHeight: '3rem'
  }
});

export enum FnButtonWidth {
  Fixed = 'fixed',
  Full = 'full',
  Auto = 'auto'
}

export const WIDTH_VALUES: Record<FnButtonWidth, string> = Object.freeze({
  [FnButtonWidth.Fixed]: '170px',
  [FnButtonWidth.Full]: '100%',
  [FnButtonWidth.Auto]: 'auto'
});
